module.exports = __webpack_public_path__ + "img/Transpordiamet_vapp_valge_eng.e5b13871.svg";